import axios from '../../../axios'



// 获取列表
export const list = (data) => {
  return axios({
    url: '/confirm/defect/list',
    method: 'post',
    data
  })
}

// 提交
export const confirm = (data) => {
  return axios({
    url: '/confirm/defect/confirm',
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/http/moudules/biz/confirm/confirmDefect.js